import React from 'react';
export function Footer() {
  return <footer className="bg-forest text-sage py-8 px-4 border-t border-sage/20" data-id="element-64">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-65">
        <p className="text-sm text-center md:text-left" data-id="element-66">
          © 2026 Recetas Saludables para Celíacos. Todos los derechos
          reservados.
        </p>
        <div className="flex gap-6 text-sm" data-id="element-67">
          <a href="#" className="hover:text-cream transition-colors" data-id="element-68">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-cream transition-colors" data-id="element-69">
            Política de Privacidad
          </a>
        </div>
      </div>
    </footer>;
}